import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

//  Users load (Pagination)
export const fetchUsers = createAsyncThunk(
  "companyRole/fetchUsers",
  async ({ page = 1, perPage = 4 }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/users?page=${page}&per_page=${perPage}`);
      return res.data; // { data, last_page }
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//  Companies load
export const fetchCompanies = createAsyncThunk(
  "companyRole/fetchCompanies",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/companies");
      console.log("company list" , res.data)
      return res.data.data || res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCompaniesWithUsersRoles = createAsyncThunk(
  "companyRole/fetchCompaniesWithUsersRoles",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/companiesWithUsersRoles");
      console.log("company list with users roles" , res.data)
      return res.data.data || res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//  Roles load
export const fetchRoles = createAsyncThunk(
  "companyRole/fetchRoles",
  async ({ companyId, companyName }, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `/api/roles?company=${encodeURIComponent(companyName)}`
      );
      return { companyId, roles: res.data };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//  User
export const updateUser = createAsyncThunk(
  "companyRole/updateUser",
  async ({ id, userData }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/api/users/${id}`, userData);
      return res.data.user || userData; // Updated user return
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//  User delete
export const deleteUser = createAsyncThunk(
  "companyRole/deleteUser",
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/api/users/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const companyRoleSlice = createSlice({
  name: "companyRole",
  initialState: {
    users: [],
    companies: [],
    roles: {}, // { companyId: [roles] }
    currentPage: 1,
    totalPages: 1,
    loading: false,
    error: null,
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setRoles: (state, action) => {
      const { companyId, roles } = action.payload;
      state.roles[companyId] = roles;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        state.totalPages = action.payload.last_page;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.companies = action.payload;
      })
      .addCase(fetchCompaniesWithUsersRoles.fulfilled, (state, action) => {
        state.companies = action.payload;
      })

      .addCase(fetchRoles.fulfilled, (state, action) => {
        const { companyId, roles } = action.payload;
        state.roles[companyId] = roles;
      })

      .addCase(updateUser.fulfilled, (state, action) => {
        const updatedUser = action.payload;
        const index = state.users.findIndex((u) => u.id === updatedUser.id);
        if (index !== -1) {
          state.users[index] = { ...state.users[index], ...updatedUser };
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter((u) => u.id !== action.payload);
      });
  },
});

export const { setCurrentPage, setRoles } = companyRoleSlice.actions;
export default companyRoleSlice.reducer;
